import ModelEntity from "../../../model2/model-entity";
import {EntityType} from "../../../gd/const/item";
import ErrorProto from "../../../gd/validation/error";
import ErrorFieldRequired from "../../../gd/validation/error-field-required";
import UserAssignment_Fields from "./fields";
import Task from "../../../model2/task/task";
import Event from "../../../model2/event/event";
import ProjectUserFull from "../../../model2/project-user/project-user-full";


export default class UserAssignment extends ModelEntity {

    public tasks        : Task[]
    public events       : Event[]
    public projects     : ProjectUserFull[]

    public userId                   : ID
    public tasksReassignUserId      : ID | null
    public eventsReassignUserId     : ID | null
    public projectReassignUserId    : ID | null

    constructor(data: any) {

        super(data.userId, EntityType.DYNAMIC_MODEL)

        this.tasks                  = _.get(data,'tasks', [])
        this.events                 = _.get(data, 'events', [])
        this.projects               = _.get(data, 'projects', [])

        this.userId                 = data.userId                   // Current assigned user
        this.tasksReassignUserId    = data.tasksReassignUserId
        this.eventsReassignUserId   = data.eventsReassignUserId
        this.projectReassignUserId  = data.projectReassignUserId
    }

    get hasAssignments() {
        return !_.isEmpty(this.tasks) || !_.isEmpty(this.events) || !_.isEmpty(this.projects)
    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        const fields = new UserAssignment_Fields()

        if (!this.projectReassignUserId && !!this.projects && this.projects.length > 0) errors.push(new ErrorFieldRequired(fields.projectReassignUserId))
        if (!this.eventsReassignUserId && !!this.events && this.events.length > 0) errors.push(new ErrorFieldRequired(fields.eventsReassignUserId))

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJSON() {
        return {
            userId                   : this.userId,                     // Current user
            tasksReassignUserId      : this.tasksReassignUserId,        // Reassign tasks user
            eventsReassignUserId     : this.eventsReassignUserId,       // Reassign event user
            projectReassignUserId    : this.projectReassignUserId       // Reassign project user
        }
    }

}
